import styled from 'styled-components';

export const ProductHeading = styled.h2`
  text-align: center;
`;

export const Divider = styled.hr`
  width: 10%;
  margin: 40px auto;
`;

export const ProductSectionWrapper = styled.div`
  max-width: 1200px;
  margin: 48px auto;
`;
